
import { mapState } from 'vuex'
export default {
  // async fetch() {
  //   if (!this.posts) {
  //     this.posts = await this.$http.$get('https://api.nuxtjs.dev/posts/1')
  //   } else {
  //   }
  // },
  props: {
    isPricingPage: {
      type: Boolean,
      required: true,
    },
    expandTopBanner: {
      type: Boolean,
      required: true,
    },
    navBarData: {
      type: Object,
      default: () => ({
        topBannerTextCurrency: '$',
        topBannerTextAmount: 30,
        topBannerTextHeader: '',
        topBannerTextContent:
          '<a href="https://www.4teamstore.com/cyberweek/?pcode=012015294flba2r&utm_campaign=CW_21&utm_source=product_website&utm_medium=top_red&utm_content=Sync_Group" style="color:white;font-size:15px;">Cyber Week Exclusive Offers. Discounts up to 80%!</a>',
        navBarClose: 'MENU_CLOSE',

        project: {
          logoSrc: 'sync2',
          name: 'Sync2',
          nameColor: 'primary',
          link: '',
        },
        links: [
          // { id: 1, isExpandable: false, isExternal: false, iconName: 'mi-download', link: '../download', name: 'MENU_DOWNLOAD', title: 'MENU_DOWNLOAD_TITLE', prefetch: '?', showIcon:"",},
          // {
          //  id: 2,
          //  isExpandable: false,
          //  isExternal: false,
          //  iconName: 'mi-features',
          //  link: '../sync2-features',
          //  name: 'MENU_FEATURES',
          //  title: 'MENU_FEATURES_TITLE',
          //  prefetch: '?',
          //  showIcon: "",
          // },
          // {
          //  id: 3,
          //  isExpandable: false,
          //  isExternal: false,
          //  iconName: 'mi-testimonials',
          //  link: '../testimonials',
          //  name: 'MENU_TESTIMONIALS',
          //  title: 'MENU_TESTIMONIALS_TITLE',
          //  prefetch: '?',
          //  showIcon: "",
          // },
          {
            id: 1,
            isExpandable: false,
            isExternal: false,
            iconName: 'mi-faq',
            DomainName: 'https://www.sync2.com/',
            PageName: 'URL_FAQ',
            name: 'MENU_FAQ',
            title: 'MENU_FAQ_TITLE',
            prefetch: '?',
            showIcon: '',
            link: 'URL_FAQ',
          },
          {
            id: 2,
            isExpandable: false,
            isExternal: false,
            iconName: 'mi-support',
            DomainName: 'https://www.sync2.com/',
            PageName: 'support',
            link: 'URL_SUPPORT',
            name: 'MENU_SUPPORT',
            title: 'MENU_SUPPORT_TITLE',
            prefetch: '?',
            showIcon: '',
          },
          // {
          //  id: 6,
          //  isExpandable: true,
          //  isExternal: false,
          //  iconName: 'mi-resources',
          //  link: '/',
          //  name: 'MENU_RESOURCES',
          //  title: 'MENU_RESOURCES_TITLE',
          //  prefetch: '?',
          //  showIcon: "",
          //  nestedLinks: [
          //    { id: 1, isExternal: false, iconName: 'blank-file', link: '../screenshots', name: 'MENU_RESOURCES_SCREENSHOTS_VIDEO', title: 'MENU_RESOURCES_SCREENSHOTS_VIDEO_TITLE', prefetch: '?' },
          //    { id: 2, isExternal: false, iconName: 'blank-file', link: '../documentation.aspx', name: 'MENU_RESOURCES_DOCUMENTATION', title: 'MENU_RESOURCES_DOCUMENTATION_TITLE', prefetch: '?' },
          //    { id: 3, isExternal: false, iconName: 'blank-file', link: '../installation-instructions', name: 'MENU_RESOURCES_INSTALLATION_INSTRUCTIONS', title: 'MENU_RESOURCES_INSTALLATION_INSTRUCTIONS_TITLE', prefetch: '?' },
          //    { id: 4, isExternal: false, iconName: 'blank-file', link: '../version-history.aspx', name: 'MENU_RESOURCES_VERSION_HISTORY', title: 'MENU_RESOURCES_VERSION_HISTORY_TITLE', prefetch: '?' },
          //    { id: 5, isExternal: false, iconName: 'blank-file', link: '../system-requirements', name: 'MENU_RESOURCES_SYSTEM_REQUIREMENTS', title: 'MENU_RESOURCES_SYSTEM_REQUIREMENTS_TITLE', prefetch: '?' },
          //    { id: 6, isExternal: false, iconName: 'blank-file', link: '../frequently-asked-questions', name: 'MENU_RESOURCES_FAQ', title: 'MENU_RESOURCES_FAQ_TITLE', prefetch: '?' },
          //    { id: 7, isExternal: false, iconName: 'blank-file', link: '../help', name: 'MENU_RESOURCES_HELP', title: 'MENU_RESOURCES_HELP_TITLE', prefetch: '?' },
          //  ],
          // },
          {
            id: 3,
            isExpandable: false,
            isExternal: true,
            iconName: 'mi-myaccount',
            DomainName: 'https://www.4team.biz/member/default.asp?',
            PageName: '',
            link: 'https://www.4team.biz/member/default.asp',
            name: 'MENU_MY_ACCOUNT',
            title: 'MENU_MY_ACCOUNT_TITLE',
            prefetch: '?',
            showIcon: '',
          },
          {
            id: 4,
            isExpandable: true,
            isExternal: false,
            iconName: 'mi-language',
            link: '/',
            name: 'MENU_SELECT_LANG',
            title: 'MENU_SELECT_LANG_TITLE',
            prefetch: '?',
            showIcon: '',
            nestedLinks: [
              { id: 1, isExternal: false, iconName: 'blank-file', link: '/purchase/licenses', name: 'English', title: 'English', prefetch: '?', locale: 'en' },
              {
                id: 2,
                isExternal: false,
                iconName: 'blank-file',
                link: '/fr/purchase/licenses',
                name: 'Français',
                title: 'Français',
                prefetch: '?',
                locale: 'fr',
              },
              {
                id: 3,
                isExternal: false,
                iconName: 'blank-file',
                link: '/de/purchase/licenses',
                name: 'Deutsch',
                title: 'Deutsch',
                prefetch: '?',
                locale: 'de',
              },
              {
                id: 4,
                isExternal: false,
                iconName: 'blank-file',
                link: '/es/purchase/licenses',
                name: 'Español',
                title: 'Español',
                prefetch: '?',
                locale: 'es',
              },
              {
                id: 5,
                isExternal: false,
                iconName: 'blank-file',
                link: '/it/purchase/licenses',
                name: 'Italliano',
                title: 'Italliano',
                prefetch: '?',
                locale: 'it',
              },
            ],
          },
          // {
          //  id: 7,
          //  isExpandable: false,
          //  isExternal: false,
          //  iconName: 'mdi-ticket',
          //  link: '../support',
          //  name: 'MENU_SELECT_LANG',
          //  title: 'MENU_SELECT_LANG_TITLE',
          //  prefetch: '?',
          // },
        ],
      }),
    },
  },
  data() {
    return {
      drawer: false,
      group: null,
      selected: false,
      isLoaded: false,
      showTopBanner: false,
      LogoImg: this.$config.CustomProductData.LogoSourceMob,
      BrandName: this.$config.CustomProductData.LogoName,
      LogoUrl: this.$config.CustomProductData.LogoLink,
      LogoImgType: this.$config.CustomProductData.LogoIsSVG,
    }
  },
  computed: mapState({
    currencies: (state) => state.currencies.currencies,
    showTopBanner2: (state) => state.navBar.showTopBanner,
    selectedCurrency: (state) => state.currencies.selectedCurrency,
    selectedLocale: (state) => state.locales.selectedLocale,
    locales: (state) => state.locales.locales,
    availableLocales() {
      return this.$i18n.locales.filter((i) => i.code !== this.$i18n.locale)
    },
  }),
  mounted() {
    if (process.browser) {
      setTimeout(() => {
        this.$store.commit(
          'locales/setSelectedLocale',
          this.$i18n.locales.find((i) => i.code === this.$i18n.locale)
        )

        this.isLoaded = true
      }, 0)
    }
  },
  methods: {
    MenuPageUrl(URLdomain, URLpage) {
      const URLlang = this.$services.culture.getLanguage()
      let MenuURL = ''
      if (URLdomain && URLdomain.includes('https://www.4team.biz/')) {
        URLdomain = URLdomain
      } else {
        URLdomain = this.$config.CustomProductData.ProductWebUrl
      }
      if (URLlang === 'de' || URLlang === 'es' || URLlang === 'fr' || URLlang === 'it') {
        MenuURL = URLdomain + URLlang + '/' + URLpage
      } else {
        MenuURL = URLdomain + URLpage
      }
      if (URLpage === '') {
        MenuURL = URLdomain + URLpage
      }
      return MenuURL
    },
    openLiveChat() {
      const ua = navigator.userAgent.toLowerCase()
      const platform = navigator?.platform.toLowerCase() || 'unknown'
      const platformName = ua.match(/ip(?:ad|od|hone)/) ? 'ios' : (ua.match(/(?:webos|android)/) || platform.match(/mac|win|linux/) || ['other'])[0]
      const isMobile = /ios|android|webos/.test(platformName)
      if (!isMobile) {
        // LC_API.open_chat_window()
        window.Tawk_API.maximize()
      } else {
        //  const url = 'https://secure.livechatinc.com/licence/10998812/v2/open_chat.cgi?groups=0'
        const url = 'https://tawk.to/chat/660d585ca0c6737bd127e31f/1hqi22aqh'
        window.open(url, '_blank')
      }
      return false
    },
    setSelectedCurrency(event) {
      this.$services.culture.setCurrency(event.currency)
      this.$store.commit('currencies/setSelectedCurrency', JSON.parse(JSON.stringify(event)))
    },
    checkMobile() {
      const ua = navigator.userAgent.toLowerCase()
      const platform = navigator?.platform.toLowerCase() || 'unknown'
      const platformName = ua.match(/ip(?:ad|od|hone)/) ? 'ios' : (ua.match(/(?:webos|android)/) || platform.match(/mac|win|linux/) || ['other'])[0]
      const isMobile = /ios|android|webos/.test(platformName)
      return isMobile
    },
    setLocale(event) {
      this.$services.culture.setLanguage(event)
      this.$store.commit(
        'locales/setSelectedLocale',
        this.$i18n.locales.find((i) => i.code === event)
      )
      this.$i18n.setLocale(event)
    },
  },
}
